/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CalendarEventConfirmation = {
    Yes: 'yes',
    No: 'no',
    Maybe: 'maybe'
} as const;
export type CalendarEventConfirmation = typeof CalendarEventConfirmation[keyof typeof CalendarEventConfirmation];

